export function clearPositionerStyles(positionerElement, originalPositionerStyles) {
  Object.assign(positionerElement.style, originalPositionerStyles);
}